module.exports = __webpack_public_path__ + "img/Badminton.3810feeb.png";